// extracted by mini-css-extract-plugin
export default {"root":"buttonsRow-module-root-OQO3W","vertical":"buttonsRow-module-vertical-esdbC","center":"buttonsRow-module-center-Dtcpe","placeholder":"buttonsRow-module-placeholder-zEiE5"};